/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jack-henry/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { AchBatchImportModelDto } from "../";
import { HttpClient, RequestParams } from "./http-client";

@Injectable()
export class AchBatchImportsClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags AchBatchImports
   * @name AchBatchImportsPost
   * @summary Imports a AchBatchImportModel.
   * @request POST:/achBatchImports
   */
  achBatchImportsPost = (params: RequestParams = {}) =>
    this.http.request<AchBatchImportModelDto, any>({
      path: `/achBatchImports`,
      method: "POST",
      format: "json",
      ...params,
    });
}
